export const GridId = 'labbprov';
export const ConfigName = 'labbprov';
export const ModuleName = 'labbprov';
export const TableName = 'Labbprov';
export const DisplayName = 'Labprov';
